// Import model
import { BomKitItem } from '../models/BomKitItem';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CatalogItem } from '../models/CatalogItem';

// Import dependency serializers (for complex types)
import { CatalogItemSerializer } from './CatalogItemSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for BomKitItem - handles JSON serialization and deserialization with type validation
 */
export class BomKitItemSerializer {
  /**
   * Deserializes a JSON string into a BomKitItem instance
   */
  static deserialize(json: string): BomKitItem {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a BomKitItem instance
   */
  static fromObject(obj: any): BomKitItem {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to BomKitItem');
    }


    const instance: BomKitItem = {
      createdBy: obj['createdBy'] as string | undefined,
      createdByName: obj['createdBy|Name'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      itemId: obj['itemId'] as string | undefined,
      itemIdName: obj['itemId|Name'] as string | undefined,
      bomKitId: obj['bomKitId'] as string | undefined,
      bomKitIdName: obj['bomKitId|Name'] as string | undefined,
      item: obj['item'] ? CatalogItemSerializer.fromObject(obj['item']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of BomKitItem instances
   */
  static deserializeArray(json: string): BomKitItem[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a BomKitItem instance to a JSON string
   */
  static serialize(instance: BomKitItem): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a BomKitItem instance to a plain object
   */
  static toObject(instance: BomKitItem): any {
    return {
      'createdBy': instance.createdBy,
      'createdBy|Name': instance.createdByName,
      'isActive': instance.isActive,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'itemId': instance.itemId,
      'itemId|Name': instance.itemIdName,
      'bomKitId': instance.bomKitId,
      'bomKitId|Name': instance.bomKitIdName,
      'item': instance.item ? CatalogItemSerializer.toObject(instance.item) : undefined,
    };
  }

  /**
   * Serializes an array of BomKitItem instances to a JSON string
   */
  static serializeArray(instances: BomKitItem[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
